<template>
  <div class="studentRow fRow jStart aCenter fullWidth wrap">
    <!-- <div class="savatar"></div> -->
    <div class="mainInfo fRow jStart aCenter growFull">
      <div class="av" v-if="data.avatar !== null && data.avatar !== undefined"
        v-bind:style="{backgroundImage: `url('https://api.rimik.ir${avatar}')`}">
        <div class="status offline"></div>
      </div>
      <div class="av fRow jCenter aCenter" v-if="data.avatar === null || data.avatar === undefined">
        {{data.firstName.substr(0, 1)}}‌{{data.lastName.substr(0, 1)}}
        <div class="status offline"></div>
      </div>
      <div class="fCol jCenter aStart growFull">
        <div class="sName">{{data.fullName}}</div>
        <div class="sGrade">{{data.grade.title}}، رشتۀ {{data.grade.field.title}}</div>
      </div>
      <div class="plan">
        <span>پلن {{data.planType}}</span>
      </div>
      <div class="phone">
        <span>{{data.mobile.replace('98', '0')}}</span>
      </div>
      <div class="date fCol jCenter aCenter">
        <span>{{formatDate(data.startTheContract)}}</span>
        <label>↓</label>
        <span>{{formatDate(data.endTheContract)}}</span>
      </div>
    </div>
    <div class="status fCol jCenter aCenter">
      <switch-button
        activeLabel="فعال"
        deactiveLabel="غیرفعال"
        style="margin-right: 16px"
        :val="status"
        @click.native="invertState"/>
    </div>
    <div class="sActions fRow jCenter aCenter">
      <div class="b fRow jStart aCenter" @click="editStudent">
        <label>مشاهده و ویرایش</label>
      </div>
      <i class="material-icons-round fRow jCenter aCenter"
        title="حذف"
        @click="deleteMode = true">delete</i>
      <i class="material-icons-round fRow jCenter aCenter"
        title="ارسال پیام"
        @click="messageModal = true">message</i>
      <i class="material-icons-round fRow jCenter aCenter"
        title="سوابق پرداخت"
        @click="goToPayments">account_balance_wallet</i>
      <i class="material-icons-round fRow jCenter aCenter"
        title="برنامه درسی"
        @click="goToHomeWork">pending_actions</i>
      <i class="material-icons-round fRow jCenter aCenter"
        title="دوره‌های دانش آموز"
        @click="coursesModal = true">ondemand_video </i>
    </div>
    <div class="deleteBox fRow jStart aCenter" v-if="deleteMode">
      <i class="material-icons-round del">delete</i>
      <div class="fCol deleteQuestion jCenter aStart">
        <div class="q">آیا از حذف {{data.fullName}} مطمئنید؟</div>
        <div class="d">این عملیات امکان بازگشت ندارد</div>
      </div>
      <div class="dbtn fRow jCenter aCenter" @click="deleteStudent">
        <i class="material-icons-round">delete_sweep</i>
        <label>بله مطمئنم، حذف شود</label>
      </div>
      <div class="mbtn fRow jCenter aCenter mini" @click="deleteMode = false">
        <i class="material-icons-round">close</i>
        <label>انصراف</label>
      </div>
    </div>
    <div class="modal fCol jCenter aCenter"
      v-if="messageModal">
      <div class="closer" @click="messageModal = false"></div>
      <div class="box fCol jCenter aCenter">
        <div class="messageTitle fullWidth fRow jStart aCenter">
          <i class="material-icons-round">message</i>
          <div class="fCol jCenter aStart growFull">
            <span class="big">ارسال پیام به {{data.fullName}}</span>
            <span class="small">پیام شما از طریق پیام رسان {{appName.faName}} ارسال میگردد</span>
          </div>
        </div>
        <div class="fullWidth fCol jStart aStart inputHolder">
          <span class="fRow jStart aCenter">
            <i class="material-icons-round"
              v-bind:class="{inpErr: messageTitle.length < 1}">account_circle</i>
            عنوان پیام - {{messageTitle.length}}/24</span>
          <div class="fRow jStart aCenter fullWidth inputWraper">
            <input
              class="transition-fast" placeholder="عنوان پیام"
              type="text" v-model="messageTitle">
          </div>
        </div>
        <div class="fullWidth fCol jStart aStart inputHolder">
          <span class="fRow jStart aCenter">
            <i class="material-icons-round"
              v-bind:class="{inpErr: message.length < 1}">account_circle</i>
            متن پیام - {{message.length}}/1000</span>
          <div class="fRow jStart aCenter fullWidth inputWraper">
            <textarea
              style="min-height: 200px"
              class="transition-fast" placeholder="متن پیام"
              type="text" v-model="message"></textarea>
          </div>
        </div>
        <div class="fRow jStart aCenter fullWidth">
          <div class="b fRow jCenter aCenter big growFull"
            @click="sendMessage"
            v-bind:class="{active: message.length > 0 && messageTitle.length > 0}">
            <i class="material-icons-round">send</i>
            <label>{{`ارسال پیام به ${data.fullName}`}}</label>
          </div>
          <div class="b fRow jStart aCenter"
            @click="messageModal = false"
            style="margin-right: 8px">
            <i class="material-icons-round">close</i>
            <label>انصراف</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fCol jCenter aCenter"
      v-if="coursesModal">
      <div class="closer" @click="coursesModal = false"></div>
      <div class="box fCol jCenter aCenter courses">
        <div class="fullWidth fCol jStart aStart inputHolder" v-if="loaded">
          <span class="fRow jStart aCenter">
            <i class="material-icons-round"
              v-bind:class="{inpErr: selectedConsultants.length < 1}">account_circle</i>
            انتخاب دوره
          </span>
          <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
            <div class="fullWidth fRow jStart aStart header wrap">
              <span class="t">دوره های «{{data.fullName}}» را انتخاب کنید</span>
              <input type="text" class="search fullWidth"
                placeholder="نام دوره را جستجو کنید"
                v-model="consultantSearch">
            </div>
            <div class="items w60 fRow jBetween aCenter wrap">
              <h2 class="fullWidth"
                v-if="filteredCourses.length !== 0">دوره‌ها را انتخاب کنید
                ({{filteredCourses.length}} دوره)
              </h2>
              <div class="item fRow jStart aCenter fullWidth transition-fast"
                @click="selectConsultant(item.id)"
                v-bind:class="{
                  selectedItem: selectedConsultants.includes(item.id),
                  gone: consultantFilter !== item.type && consultantFilter !== 0,
                }"
                v-for="(item, index) in filteredCourses" v-bind:key="index">
                <i class="check material-icons-round">
                  {{!selectedConsultants.includes(item.id)
                    ? 'radio_button_unchecked' : 'task_alt'}}
                </i>
                <div class="fCol growFull jCenter aStart" style="margin-right: 8px">
                  <span class="name fullWidth">{{item.title}}</span>
                  <span class="teacher fullWidth">{{item.teacher}}</span>
                </div>
                <span class="type">{{item.type}}</span>
              </div>
              <div class="noResult fCol fullWidth jCenter aCenter"
                v-if="filteredCourses.length === 0">
                <i class="material-icons-round">error</i>
                <span>نتیجه‌ای یافت نشد</span>
                <div class="mini" @click="consultantSearch = ''">حذف فیلتر</div>
              </div>
            </div>
            <div class="selectedItems w40 fCol jStart aCenter">
              <h2 class="fullWidth">دوره‌های انتخاب شده:</h2>
              <div class="item fRow jStart aCenter fullWidth transition-fast"
                v-for="(item, index) in selectedItems" v-bind:key="index">
                <span class="index">{{index + 1}}</span>
                <div class="fCol jCenter aStart growFull">
                  <span class="name">{{item.title}}</span>
                  <span class="teacher">{{item.teacher}}</span>
                  <span class="type">{{item.type}}</span>
                </div>
                <i class="ac material-icons-round"
                  @click="deleteConsultant(item.id)">delete</i>
              </div>
              <div class="noResult fCol fullWidth jCenter aCenter"
                v-if="selectedItems.length === 0">
                <i class="material-icons-round">error</i>
                <span>هیچ دوره‌ای انتخاب نشده</span>
                <!-- <div class="mini"></div> -->
              </div>
            </div>
          </div>
          <div class="fullWidth fRow jStart aCenter">
            <div class="b fRow jStart aCenter active"
              @click="setStudentCourses">
              <i class="material-icons-round">save</i>
              <label>ذخیره</label>
            </div>
            <div class="b fRow jStart aCenter">
              <i class="material-icons-round">close</i>
              <label>بستن</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchButton from '@/components/SwitchButton.vue';
import moment from 'moment-jalaali';
import makeToast from '@/mixins/makeToast';
import errorHandler from '@/mixins/mixin';
// import moment from 'moment-jalaali';
import axios from 'axios';
import 'vue-cool-select/dist/themes/material-design-dark.scss';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data', 'idx'],
  components: {
    SwitchButton,
  },
  data() {
    return {
      messageModal: false,
      messageTitle: '',
      message: '',
      coursesModal: false,
      // message ↑
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      addPay: false,
      addAdvisor: false,
      status: false,
      editMode: false,
      expanded: false,
      assignmentDates: {
        from: '',
        to: '',
        duration: '',
      },
      paymentModal: false,
      paymentLoad: false,
      advisorModal: false,
      deleteModal: false,
      parentModal: false,
      modal: false,
      advisors: [
        {
          consultantId: '1',
          consultantFullName: 'مشاور یک',
        },
        {
          consultantId: '2',
          consultantFullName: 'مشاور 2',
        },
        {
          consultantId: '3',
          consultantFullName: 'مشاور 3',
        },
        {
          consultantId: '4',
          consultantFullName: 'مشاور 4',
        },
        {
          consultantId: '5',
          consultantFullName: 'مشاور 5',
        },
      ],
      sAdvisor: '',
      sAdvisorId: '',
      sAdvisorIdErr: true,
      payments: [],
      // form
      sFirstName: '',
      sFirstNameErr: true,
      sLastName: '',
      sLastNameErr: true,
      sContractStart: '',
      sContractEnd: '',
      sPlan: '',
      sFatherName: '',
      sFatherNameErr: true,
      sNationalCode: '',
      sNationalCodeErr: true,
      sUserName: '',
      sField: 0,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      conventions: [],
      conventionsData: [],
      convention: '',
      conventionErr: true,
      // simple example of items
      fields: [
        {
          id: -1,
          title: 'رشته انتخاب نشده',
        },
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'هنر',
        },
        {
          id: 6,
          title: 'زبان',
        },
      ],
      field: '',
      fieldErr: true,
      // pay datas
      payMethods: [
        {
          id: 1,
          title: 'پرداخت نقدی',
        },
        {
          id: 2,
          title: 'پرداخت کارت به کارت',
        },
        {
          id: 3,
          title: 'پرداخت چکی',
        },
        {
          id: 4,
          title: 'پرداخت نشده',
        },
      ],
      payMethod: '',
      payMethodErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      payDesc: '',
      payDescErr: true,
      deleteMode: false,
      // courses
      consultantType: '',
      consultantTypeErr: true,
      consultantFilter: 0,
      consultants: [],
      consultantSearch: '',
      selectedConsultants: [],
      selectedConsultantsErr: true,
      selectedItems: [],
    };
  },
  watch: {
    payDate() {
      if (this.payDate !== '') {
        // console.log('date', this.payDate);
        this.payDateShow = moment(this.payDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.payDateErr = false;
      } else {
        this.payDateErr = true;
        this.payDateShow = '';
      }
    },
    startDate() {
      if (this.startDate !== '') {
        // this.sContractStart = startDate;
        // console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // this.sContractEnd = endDate;
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.etErr = true;
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    payDesc() {
      if (this.payDesc.length === 0) {
        this.payDescErr = true;
      } else if (this.payDesc.length > 128) {
        this.payDesc = this.payDesc.substr(0, 128);
        this.payDescErr = false;
      } else {
        this.payDescErr = false;
      }
    },
    sContractStart() {
      this.startDate = this.sContractStart;
    },
    sContractEnd() {
      this.endDate = this.sContractEnd;
    },
    // validations
    sAdvisorId() {
      if (this.sAdvisorId !== '') {
        this.sAdvisorIdErr = false;
      } else {
        this.sAdvisorIdErr = true;
      }
    },
    sFirstName() {
      if (this.sFirstName !== '' && this.sFirstName !== null) {
        if (this.sFirstName.length > 24) {
          this.sFirstName = this.sFirstName.substr(0, 24);
        }
        this.sFirstNameErr = false;
      } else {
        this.sFirstNameErr = true;
      }
    },
    sLastName() {
      if (this.sLastName !== '' && this.sLastName !== null) {
        if (this.sLastName.length > 24) {
          this.sLastName = this.sLastName.substr(0, 24);
        }
        this.sLastNameErr = false;
      } else {
        this.sLastNameErr = true;
      }
    },
    sFatherName() {
      if (this.sFatherName !== '' && this.sFatherName !== null) {
        if (this.sFatherName.length > 24) {
          this.sFatherName = this.sFatherName.substr(0, 24);
        }
        this.sFatherNameErr = false;
      } else {
        this.sFatherNameErr = true;
      }
    },
    sNationalCode() {
      if (this.sNationalCode >= 0 && this.sNationalCode !== null) {
        if (this.sNationalCode.length > 10) {
          this.sNationalCode = this.sNationalCode.substr(0, 10);
          this.sNationalCodeErr = false;
        } else if (this.sNationalCode < 10) {
          this.sNationalCodeErr = true;
        } else {
          this.sNationalCodeErr = false;
        }
      } else {
        this.sNationalCodeErr = true;
      }
    },
    field() {
      if (this.field.length !== 0) {
        this.fieldErr = false;
        if (this.field.id === -1) {
          this.fieldErr = true;
        }
      } else {
        this.fieldErr = false;
      }
    },
    convention() {
      if (this.convention.length > 0) {
        this.sAdvisorIdErr = false;
      } else {
        this.sAdvisorIdErr = true;
      }
    },
    coursesModal() {
      if (this.coursesModal) {
        this.getCourses();
      }
    },
    selectedConsultants() {
      this.selectedItems = [];
      for (let i = 0; i < this.consultants.length; i += 1) {
        if (this.selectedConsultants.includes(this.consultants[i].id)) {
          this.selectedItems.push(this.consultants[i]);
        }
      }
      if (this.selectedConsultants.length === 0) {
        this.selectedConsultantsErr = true;
      } else {
        this.selectedConsultantsErr = false;
      }
    },
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    goToPayments() {
      this.$store.commit('setAccounting', this.data);
      this.$router.push('/accounting');
    },
    goToHomeWork() {
      this.$store.commit('setHomeWork', this.data);
      this.$router.push('/homework');
    },
    dateMoment(d) {
      return moment(d, 'YYYY-MM-DDTHH:mm:00')
        .locale('FA')
        .format('jDD jMMMM jYYYY');
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          this.fieldErr = false;
          break;
        }
        case 'plan': {
          this.planErr = false;
          break;
        }
        case 'convention': {
          this.conventionErr = false;
          this.consultantId = e.id;
          this.sAdvisorId = e.id;
          break;
        }
        case 'payMethod': {
          this.payMethodErr = false;
          if (this.payMethod.id === 4) {
            this.notPayed = true;
            this.payDate = '';
          } else {
            this.notPayed = false;
          }
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    changeState() {
      this.status = !this.status;
    },
    openModal(modal) {
      this.modal = true;
      switch (modal) {
        case 'payment': {
          this.paymentModal = true;
          this.getPayment();
          break;
        }
        case 'advisor': {
          this.advisorModal = true;
          this.getCourses();
          break;
        }
        case 'delete': {
          this.deleteModal = true;
          break;
        }
        case 'parent': {
          this.parentModal = true;
          break;
        }
        default:
          break;
      }
    },
    closeModal() {
      this.paymentModal = false;
      this.advisorModal = false;
      this.deleteModal = false;
      this.parentModal = false;
      this.modal = false;
    },
    invertState() {
      axios({
        method: 'patch',
        url: `${this.baseURL}/api/v${this.V}/Students/${this.data.studentId}?status=${!this.status}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.status = !this.status;
          if (this.gradeStatus) {
            this.makeToast('success', 'دانش آموز مورد نظر فعال شد', 2000);
          } else {
            this.makeToast('success', 'دانش آموز مورد نظر غیرفعال شد', 2000);
          }
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    editStudent() {
      this.$emit('edit', this.data);
    },
    getPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments/${this.data.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.payments = response.data.data;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    deleteStudent() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Students/${this.data.studentId}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.$emit('refresh');
          this.makeToast('success', 'تفاهم نامه با موفقیت حذف شد', 3000);
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    newPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments`;
      axios({
        method: 'post',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          userId: this.data.userId,
          paymentType: this.payMethod.title,
          paymentAmount: this.payAmount.replace(/,/g, ''),
          paymentDate: this.payDate,
          paymentDescription: this.payDesc,
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.getPayment();
          this.clearPayForm();
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    clearPayForm() {
      this.payDate = '';
      this.payAmount = '';
      this.payMethod = '';
      this.payDesc = '';
    },
    cancelEdit() {
      this.init();
      this.editMode = false;
    },
    init() {
      this.status = this.data.status;
    },
    // format date
    formatDate(d) {
      let dd = '';
      if (d.includes('0001')) {
        dd = 'نیاز به بررسی';
      } else {
        dd = moment(d, 'YYYY-MM-DDTHH:mm:ss')
          .locale('fa')
          .format('jDD jMMMM jYYYY');
      }
      return dd;
    },
    sendMessage() {
      if (this.message.length > 0 && this.messageTitle.length > 0) {
        this.makeToast('success', 'پیام شما ارسال شد', 3000);
        this.messageModal = false;
      } else {
        this.makeToast('error', 'فرم را تکمیل کنید', 3000);
      }
    },
    getCourses() {
      this.setMode('loading');
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Courses/All`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'مشاور ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
            this.consultants = [];
            for (let i = 0; i < this.conventionsData.length; i += 1) {
              const a = {
                id: this.conventionsData[i].id,
                title: this.conventionsData[i].title,
                teacher: this.conventionsData[i].teacherFullName,
                type: this.conventionsData[i].fullLesson,
              };
              this.consultants.push(a);
            }
            this.getStudentCourses();
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    getStudentCourses() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Students/courses/${this.data.studentId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.setMode('loaded');
        if (response.data.isSuccess) {
          const arr = response.data.data;
          if (arr !== null) {
            this.selectedConsultants = [];
            this.selectedItems = [];
            for (let i = 0; i < arr.length; i += 1) {
              this.selectConsultant(arr[i]);
            }
          }
          // console.log(response.data.data);
        } else {
          // console.log(response.data.data);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    setStudentCourses() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Students/${this.data.studentId}/courses`;
      axios({
        method: 'patch',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          coursesId: this.selectedConsultants.length === 0 ? [] : this.selectedConsultants,
        },
      }).then((response) => {
        this.setMode('loaded');
        if (response.data.isSuccess) {
          this.makeToast('success', response.data.message, 3000);
          this.coursesModal = false;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    // course modal methods
    selectConsultant(id) {
      const isThere = this.selectedConsultants.indexOf(id);
      if (isThere === -1) {
        this.selectedConsultants.push(id);
      } else {
        this.selectedConsultants.splice(isThere, 1);
      }
      // console.log(this.selectedConsultants);
    },
    deleteConsultant(i) {
      // console.log(i);
      const index = this.selectedConsultants.indexOf(i);
      this.selectedConsultants.splice(index, 1);
    },
  },
  computed: {
    filteredCourses() {
      // eslint-disable-next-line
      return this.consultants.filter((item) => item.title.toLowerCase().includes(this.consultantSearch.toLowerCase()));
    },
    isPayReady() {
      let a = false;
      if (this.notPayed) {
        a = !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      } else {
        a = !this.payDateErr
          && !this.payAmountErr
          && !this.payMethodErr
          && !this.payDescErr;
      }
      return a;
    },
    contractDuration() {
      if (this.startDate !== '' && this.endDate !== '') {
        return Math.round(moment(this.endDate).diff(this.startDate, 'months', true));
      }
      return '~';
    },
    isEditReady() {
      const a = !this.sAdvisorIdErr
        && !this.sFirstNameErr
        && !this.sLastNameErr
        && !this.stErr
        && !this.etErr
        && !this.sNationalCodeErr
        && !this.sFatherNameErr
        && !this.fieldErr;
      return a;
    },
    appName() {
      return this.$store.state.appName;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style lang="scss" scoped>
.studentRow {
  padding: 8px;
  border-radius: 16px 48px 48px 16px;
  $av: 48px;
  position: relative;
  overflow: hidden;
  background-color: rgba($color: #000000, $alpha: 0.0);
  $dash: dashed 1px rgba(0,0,0,0.15);
  .mainInfo {
    .av {
      width: $av;
      height: $av;
      margin-left: 8px;
      border-radius: 50%;
      line-height: 1;
      font-size: 12px;
      font-weight: bold;
      background-color: rgba($color: #000000, $alpha: 0.10);
      position: relative;
      .status {
        position: absolute;
        $pos: calc(100% - 14px);
        top: $pos;
        left: $pos;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        border: solid 2px;
        box-shadow: 0 4px 4px -2px rgba($color: #000000, $alpha: 0.45);
      }
      .status.offline {
        background-color: rgba($color: #575757, $alpha: 1.0);
        border-color: rgba($color: #919191, $alpha: 1.0);
      }
    }
    .sName {
      font-size: 16px;
    }
    .sGrade {
      font-size: 10px;
    }
    .plan {
      width: 116px;
      border: dashed 1px rgba($color: #000000, $alpha: 0.15);
      border-top: none;
      border-bottom: none;
      span {
        padding: 2px 6px;
        border-radius: 16px;
        background-color: rgba($color: rgb(70, 150, 70), $alpha: 1.0);
        color: white;
        font-size: 10px;
      }
    }
    .phone {
      width: 106px;
      border-left: dashed 1px rgba($color: #000000, $alpha: 0.15);
      span {
        padding: 2px 6px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .date {
      width: 126px;
      span {
        padding: 2px 6px;
        border-radius: 16px;
        font-size: 10px;
      }
      label {
        font-size: 12px;
        line-height: 1;
        opacity: 0.2;
        margin-bottom: -2px;
      }
    }
  }
  .status {
    width: 96px;
  }
  .sActions {
    margin-right: 16px;
    i {
      margin: 4px;
      border-radius: 50%;
      padding: 6px;
      font-size: 12px;
      cursor: pointer;
      background-color: rgba($color: #000000, $alpha: 0.15);
    }
    i.active {
      background-color: rgba($color: #67ee45, $alpha: 1);
    }
    @keyframes empty {
      0% {
        box-shadow: 0 0 0 4px rgba($color: red, $alpha: 0.35);
      }
      100% {
        box-shadow: 0 0 0 4px rgba($color: red, $alpha: 0.0);
      }
    }
    i.empty {
      animation: empty cubic-bezier(1, 0, 0, 1) 2s infinite alternate;
      background-color: rgba($color: red, $alpha: 1.0);
      color: white;
    }
  }
  .deleteBox {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: red;
    z-index: 200;
    padding: 0 16px;
    i.del {
      font-size: 32px;
      color: white;
      text-shadow: 0 4px 0px rgba($color: #000000, $alpha: 0.25);
      margin-left: 16px;
    }
    .deleteQuestion {
      margin-left: 16px;
      .q {
        font-size: 16px;
        font-weight: bold;
        color: white;
      }
      .d {
        font-size: 12px;
        color: white;
      }
    }
    .dbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: white;
      color: #000000;
      margin-left: 8px;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 16px;
      }
      label {
        font-size: 14px;
      }
    }
    .mbtn {
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: rgba(0, 0, 0, 0.082);
      color: #ffffff;
      * {
        pointer-events: none;
      }
      i {
        margin-left: 4px;
        font-size: 12px;
        color: white;
      }
      label {
        font-size: 12px;
        font-weight: bold;
        color: white;
      }
    }
  }
  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 5000000;
    background-color: rgba($color: #000000, $alpha: 0.05);
    backdrop-filter: blur(8px);
    .closer {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 10;
    }
    .box {
      border-radius: 16px;
      padding: 24px;
      background-color: white;
      width: 80%;
      max-width: 850px;
      z-index: 15;
      max-height: 75vh;
      box-shadow: 0 16px 24px 0 rgba($color: #000000, $alpha: 0.45);
      .messageTitle {
        padding-bottom: 24px;
        margin-bottom: 16px;
        border-bottom: solid 1px rgba($color: #000000, $alpha: 0.05);
        i {
          margin-left: 8px;
          font-size: 16px;
          padding: 8px;
          background-color: rgba($color: #000000, $alpha: 0.10);
          border-radius: 24px;
        }
        span.big {
          font-size: 14px;
          font-weight: bold;
          text-align: right;
        }
        span.small {
          font-size: 10px;
          margin-top: 0px;
          text-align: right;
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
    }
    .box.courses {
      max-width: 1200px !important;
    }
  }
}
.studentRow:nth-child(odd) {
  background-color: rgba($color: #000000, $alpha: 0.05) !important;
}
.inputHolder {
  height: 100%;
}
.consultantHolder {
  input {
    outline: 0;
    margin-top: 16px;
    padding: 8px 16px;
    border: solid 1px rgba($color: #000000, $alpha: 0.35);
  }
  padding: 16px;
  .header {
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
    span.t {
      font-size: 14px;
      text-align: right;
      margin-left: 16px;
      color: black;
    }
    .filters {
      span.o {
        font-size: 12px;
        font-weight: bold;
        margin-left: 16px;
      }
      .cheap {
        padding: 4px 8px;
        border-radius: 24px;
        background-color: rgba($color: #000000, $alpha: 0.05);
        font-size: 12px;
        margin-left: 8px;
        cursor: pointer;
      }
      .cheap.selected {
        background-color: rgba($color: #273a64, $alpha: 1);
        box-shadow: 0 12px 12px -12px rgba($color: #000000, $alpha: 1);
        color: white;
      }
    }
  }
  .items {
    overflow: hidden auto;
    padding: 16px;
    padding-bottom: 8px;
    border-radius: 16px;
    max-height: 283px;
    border: solid 2px rgba($color: #000000, $alpha: 0.05);
    .item {
      border-radius: 16px;
      padding: 8px;
      margin-bottom: 8px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      cursor: pointer;
      * {
        pointer-events: none;
      }
      i.check {
        font-size: 16px;
        margin-left: 4px;
      }
      span.name {
        font-size: 14px;
        font-weight: bold;
        color: #303030;
        text-align: right;
      }
      span.teacher {
        font-size: 12px;
        color: #303030;
        text-align: right;
      }
      span.type {
        font-size: 10px;
        font-weight: 200;
        color: #646464;
        text-align: left;
        width: 112px;
      }
    }
    .item.gone {
      display: none;
    }
    .item:nth-child(2n+1) {
      background-color: rgba($color: #000000, $alpha: 0.0);
    }
    .item:hover {
      background-color: rgba($color: #000000, $alpha: 0.05);
    }
    .item.selectedItem {
      border: solid 2px rgba($color: #19b146, $alpha: 0.85) !important;
      background-color: rgba($color: #000000, $alpha: 0.05);
    }
  }
  h2 {
    padding: 0;
    margin: 0 0 16px 0;
    font-size: 14px;
    padding-bottom: 16px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
  }
  .selectedItems {
    padding: 16px;
    border-radius: 16px;
    max-height: 283px;
    overflow: hidden auto;
    border: solid 2px rgba($color: #000000, $alpha: 0.05);
    .item {
      border-radius: 24px 8px 8px 24px;
      padding: 4px 8px 4px 4px;
      margin-bottom: 8px;
      cursor: pointer;
      span.index {
        margin-left: 4px;
        font-size: 10px;
        text-align: right;
        min-width: 16px;
        width: 16px;
        line-height: 1;
      }
      span.name {
        font-size: 14px;
        font-weight: bold;
        color: #303030;
        text-align: right;
      }
      span.teacher {
        font-size: 12px;
        color: #303030;
        text-align: right;
        padding-bottom: 8px;
        border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
        margin-bottom: 8px;
      }
      span.type {
        font-size: 10px;
        font-weight: bold;
        color: #646464;
        white-space: nowrap;
        text-align: left;
      }
      i.ac {
        font-size: 16px;
        padding: 8px;
        margin-right: 8px;
        border-radius: 50%;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      i.ac:hover {
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
    }
    .item:nth-child(2n+1) {
      background-color: rgba($color: #000000, $alpha: 0.02);
    }
    .item:last-child {
      margin-bottom: 0;
    }
  }
  .noResult {
    height: 192px;
    i {
      font-size: 24px;
      color: rgba($color: #000000, $alpha: 0.25);
      margin-bottom: 8px;
    }
    span {
      font-size: 12px;
      width: 80%;
      text-align: center;
    }
    .mini {
      font-size: 12px;
      cursor: pointer;
      margin-top: 16px;
      padding: 4px 8px;
      border-radius: 16px;
      background-color: rgba($color: #000000, $alpha: 0.05);
    }
    .mini:hover {
      background-color: rgba($color: #000000, $alpha: 0.08);
    }
  }
}
</style>
